import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VaultSideNavService {
  constructor() {}
  isOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  vaultSideNavOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isModalClosed: BehaviorSubject<boolean> = new BehaviorSubject(false);

  handleNav(val: boolean) {
    this.isOpened.next(val);
  }
  
  handleModal(val) {
    this.isModalClosed.next(val);
  }
  
  handleVaultSideNav(val: boolean) {
    this.vaultSideNavOpened.next(val);
  }
}
